/**
 * Note: this tag is also set in `src/theme/sections/main-product.liquid`.
 */
const KIDS_TAG = "brand--kids";

export const tagFilterKids = {
  match: {
    tags: KIDS_TAG,
  },
};

export const tagFilterMens = {
  bool: {
    must_not: {
      match: {
        tags: KIDS_TAG,
      },
    },
  },
};

export const isKids = () => {
  return localStorage.getItem("isKids") === "true";
};

export const setIsKids = (isKids: boolean) => {
  localStorage.setItem("isKids", isKids ? "true" : "false");
};
